import { render, staticRenderFns } from "./in-shelf.vue?vue&type=template&id=b7fbb9a6&scoped=true"
import script from "./in-shelf.vue?vue&type=script&lang=tsx"
export * from "./in-shelf.vue?vue&type=script&lang=tsx"
import style0 from "./in-shelf.vue?vue&type=style&index=0&id=b7fbb9a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fbb9a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7fbb9a6')) {
      api.createRecord('b7fbb9a6', component.options)
    } else {
      api.reload('b7fbb9a6', component.options)
    }
    module.hot.accept("./in-shelf.vue?vue&type=template&id=b7fbb9a6&scoped=true", function () {
      api.rerender('b7fbb9a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouse/shelf/in-shelf.vue"
export default component.exports